/**
 * A escolha "Sem vivência" do seletor de vivência da bandeja (#100).
 *
 * Um valor do próprio seletor, e não um estado à parte, porque é uma opção dele como "Todas as vivências" e cada
 * vivência. O id de uma vivência é um UUID: "sem" não colide com nenhum.
 */
export const SEM_VIVENCIA = "sem";

/** O que a escolha do seletor pede ao servidor: as fotos sem vivência, as de uma vivência, ou todas. */
export function filtroDeVivencia(
  escolha: string,
): { semVivencia: true } | { vivenciaId: string } | Record<string, never> {
  if (escolha === SEM_VIVENCIA) return { semVivencia: true };
  return escolha ? { vivenciaId: escolha } : {};
}

/**
 * A vivência depois de trocar o Local: uma vivência só existe dentro de um Local e sai; "Sem vivência" não é de
 * Local nenhum e fica — "Sem vivência" e o Local juntos são as fotos sem IA daquele Local.
 */
export function vivenciaAoTrocarDeLocal(escolha: string): string {
  return escolha === SEM_VIVENCIA ? SEM_VIVENCIA : "";
}
